import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { UserInfoComponent } from '../../user-info/user-info.component';

@Component({
    selector: 'app-custom-cell-salesperson',
    templateUrl: './custom-cell-salesperson.component.html',
    styleUrls: ['./custom-cell-salesperson.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [UserInfoComponent]
})
export class CustomCellSalespersonComponent implements ICellRendererAngularComp {
    params!: any;
    users: any[] | undefined;

    refresh(): boolean {
        return false;
    }

    agInit(params: ICellRendererParams<any, any, any>): void {
        this.params = params;

        if (params.data.opportunityUsers) {
            this.users = params.data.opportunityUsers;
        } else {
            const fieldName = params.colDef?.field;
            this.users = fieldName ? this.params.data[fieldName] : '';
        }
    }
}
